import { Wrapper } from "AppReact";
import styled, { css } from "styled-components";


const template = styled.div`
  ${({ displayState }) => {
    return css`
    display: flex;
    > * {
      transition: transform 0.3s ease; /* Smooth transition for rotation */
      transform: ${displayState?.direction === 'up' ? 'rotate(180deg)' : 'rotate(0deg)'};
    }
  `}}
`;

export default Wrapper(template);
